import { MarkdownPanel } from "@/components/MarkdownPanel";
import { WorkspacePanel } from "@/components/WorkspacePanel";
import "./index.css";

export function App() {
  return (
    <main className="grid min-h-dvh grid-cols-1 bg-page lg:h-dvh lg:min-h-0 lg:grid-cols-2 lg:overflow-hidden">
      <MarkdownPanel />
      <WorkspacePanel />
    </main>
  );
}

export default App;
